import { makeAutoObservable } from 'mobx';
import axios from 'axios';
import _ from 'lodash';
import POPULAR_APPS from './popularApps';

const CLIENT_ID = import.meta.env.VITE_ZAPIER_CLIENT_ID;
const RESULTS_PER_PAGE = 30;

class MarketplaceContainerState {
  search = '';
  zapierResults = {};
  loadingResults = false;
  selectedPopularApp = {};
  page = 1;

  constructor() {
    makeAutoObservable(this);
  }

  async load() {
    await this.fetchResults(`https://api.zapier.com/v1/apps?client_id=${CLIENT_ID}&per_page=${RESULTS_PER_PAGE}`);
  }

  async searchApps(search) {
    this.search = search;
    await this.fetchResults(`https://api.zapier.com/v1/apps?client_id=${CLIENT_ID}&per_page=${RESULTS_PER_PAGE}&title_search=${this.search.replace(' ', '+')}`);
    this.page = 1;
  }

  async fetchResults(link) {
    this.loadingResults = true;
    const response = await axios.get(link);
    this.zapierResults = response.data;
    this.loadingResults = false;
  }

  async prevPage() {
    await this.fetchResults(this.zapierResults.prev_url);
    this.page -= 1;
  }

  async nextPage() {
    await this.fetchResults(this.zapierResults.next_url);
    this.page += 1;
  }

  get prevEnabled() {
    return !!this.zapierResults.prev_url;
  }

  get nextEnabled() {
    return !!this.zapierResults.next_url;
  }

  get endEntryIndex() {
    return _.min([this.totalResults, this.zapierResults.page * RESULTS_PER_PAGE]);
  }

  get startEntryIndex() {
    if (!this.totalResults) return 0;

    return (this.zapierResults.page * RESULTS_PER_PAGE) - RESULTS_PER_PAGE + 1;
  }

  get totalResults() {
    return this.zapierResults.total;
  }

  get popularApps() {
    if (this.page !== 1) return [];
    if (!this.search) return POPULAR_APPS;

    return _.filter(POPULAR_APPS, (value) => _.includes(value.title.toLowerCase(), this.search.toLowerCase()));
  }
}

export default MarketplaceContainerState;
